import axios from 'axios';

export default async (commit, getters) => {
    let data;
    if (getters.isPurchaseLink) {
        try {
            ({data} = await axios.post('/api/v1/validate/opportunity', {
                purchaseLinkId: getters.purchaseInfo.purchaseLinkId,
            }));
            if (!data.valid) {
                commit('setLinkError', {
                    active: true,
                });
                commit('setInitialLoading', false);
                return;
            }
        } catch (error) {
            if (window.axios.isAxiosError(error)) {
                if (!!error.response) {
                    const errorObj = error.response.data;
                    window.Sentry.logError(error, {server_event_id: error.response.data.eventId});
                    commit('setLinkError', {
                        active: true,
                        code: errorObj.error,
                    });
                    return;
                } else {
                    window.Sentry.logError(error);
                    commit('setLinkError', {
                        active: true,
                        code: window.constants.errorCodes.generalError,
                    });
                }
            } else if (!getters.hasActiveError) {
                window.Sentry.logError(error);
                commit('setLinkError', {
                    active: true,
                    code: window.constants.errorCodes.generalError
                });
            }
            commit('setInitialLoading', false);
            return;
        }
    }
}
